import { useRef } from 'react';
import styled from 'styled-components';

import SlateRichTextViewer from './SlateRichTextViewer';
import { SlideElementTextType } from './slide.types';

const SlideElementText = ({
  element,
  richTextEditorPrefix,
  content,
  showPlaceHolder = false,
  style,
}: {
  element: SlideElementTextType;
  richTextEditorPrefix: string;
  content?: string;
  showPlaceHolder?: boolean;
  style?: React.CSSProperties;
}) => {
  const textElementHeightRef = useRef<HTMLDivElement>(null);
  if (!content) return null;
  return (
    <TextElementHeightContainer ref={textElementHeightRef}>
      <SlateRichTextViewer
        style={style}
        content={content}
        id={`${richTextEditorPrefix}${element.id}`}
        showPlaceHolder={showPlaceHolder}
      />
    </TextElementHeightContainer>
  );
};

const TextElementHeightContainer = styled.div``;
export default SlideElementText;
